import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';
import { Trans, useTranslation } from 'react-i18next';

function SignInTop() {
    const { t } = useTranslation('signIn');
    const custom = useAppCustom();
    return (
        <Column spacing={30} align='center' fullWidth>
            <LogoImage src={custom?.main.logo}
                alt={t('logo.alt')} />
            <Text size='lg' style={{ textAlign: 'center' }}>
                <Trans ns='signIn'
                    i18nKey='logo.description'
                    components={{ br: <br/> }} />
            </Text>
        </Column>
    );
}

const LogoImage = styled(Image)`
    width: 220px;
`;

export default SignInTop;
